import { Component, Inject, Injector, Input, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { PhoenixViewerService } from "../../viewer-components/services/internal-services/viewer-services/phoenix-viewer.service";
import { VectorTileLayerComponent } from "./vector-tile-layer.component";
import { PhoenixVectorTileLayerResultsDialogComponent } from "../vector-tile-layer-results-dialog/phoenix-vector-tile-layer-results-dialog.component";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  selector: "phoenix-vector-tile-component",
  templateUrl: "./vector-tile-layer.component.html",
  styleUrls: ["./vector-tile-layer.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PhoenixVectorTileLayerComponent extends VectorTileLayerComponent {
  constructor(
    http: HttpClient,
    viewerConfigurationService: ViewerConfigurationService,
    geoJSONDatabaseService: GeoJSONDatabaseService,
    matDialog: MatDialog,
    public injector: Injector,
    @Inject(VIEWER_SERVICE) public viewerService: BaseViewerService,
  ) {
    super(http, viewerConfigurationService, geoJSONDatabaseService, matDialog);
  }

  loadLayers() {
    const dialog = this.matDialog.open(PhoenixVectorTileLayerResultsDialogComponent, {
      data: {
        viewerService: this.viewerService,
        url: this.url,
        username: this.form.get("username").value,
        password: this.form.get("password").value,
        isArcGISAuth: this.isArcGISAuth,
        isAuthRequired: this.isAuthRequired,
        urlTiles: this.urlTiles,
        urlStyles: this.urlStyles,
        maxZoom: this.maxZoom,
        minZoom: this.minZoom,
      },
      panelClass: "medium-panel-dialog",
      autoFocus: false,
      injector: this.injector,
    });
    dialog.afterClosed().subscribe(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "";
    });
  }
}
